<template>
  <div>
    <el-form :model="profile" style="padding: 30px 0px 10px 40px" ref="profile"
             label-width="40%">

      <el-form-item label="First name">
        <el-input type="text" style="width: 80%" placeholder="FirstName" v-model="profile.userName"
        />
      </el-form-item>

      <el-form-item label="Last Name">
        <el-input type="text" style="width: 80%" placeholder="Last Name" v-model="profile.lastName"/>
      </el-form-item>

      <el-form-item label="organization">
        <el-input type="text" style="width: 80%" placeholder="Organization" v-model="profile.organization"/>
      </el-form-item>

      <el-form-item label="Phone">
        <el-input type="text" style="width: 80%" placeholder="Phone" v-model="profile.phone"/>
      </el-form-item>


      <el-form-item label="Address">
        <el-input
          type="textarea"
          :rows="2"
          placeholder="Address"
          v-model="profile.address"
          style="width: 80%">
        </el-input>
      </el-form-item>

      <div class="footer">
        <el-form-item>
          <el-button :loading="loading" type="primary" @click="submit()">Submit</el-button>
          <el-button @click="$emit('closeDialog')">Cancel</el-button>
        </el-form-item>
      </div>
    </el-form>

  </div>

</template>

<script>
  import {mapGetters} from "vuex";
  import {post} from "./../../../../API/cloudFunctions"

  export default {

    name: "profile-details",
    data() {
      return {profile: {userName: '', lastName: '', organization: '', phone: '', address: ''}, loading: false}
    },
    computed: {
      ...mapGetters(['currentUser'])
    },
    created() {
      this.profile = this.currentUser
    },
    methods: {
      submit() {
        this.loading = true;
        post('updateUser', {updates: this.profile}).then(success => {
          this.$message.success('user details updated.')
          this.loading = false;

        }).catch(error => {
          this.loading = false;

          this.$message.error('oops,unable to update user details')

        });
      }
    }


  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/layout/components/profile/ProfileDetails.vue